import { Link } from 'react-router-dom';
import './Stempel.css';
import { ReactNode, memo } from 'react';

interface StempelProps {
  children?: ReactNode;
}

const Stempel: React.FC<StempelProps> = memo(({ children }) => (
  <div id="center">
    <div className="center">

    <div id="right_column">
      <div className="right_column_front">
        <div className="right_content">
        <img
            src="/images/portrait.webp"
            alt="Сергей Мавроди"
            width="201"
            height="231" 
          />
          <br/>
          
          <img className='poem'
            src="/images/poem.png"
            alt="Ганнибал"
            width="194"
            height="292" 
          />

          <Link to="/contacts" className="contacts-link" aria-label="Перейти на страницу Контакты">КОНТАКТЫ</Link>
          
          {/* <Link to="/museum" className="museum-link" aria-label="Музей">
          <div className="museum-title">МУЗЕЙ<br/>МАВРОДИ</div>
          <div className="museum-sub">«МЕМОРИАЛЬНЫЙ»</div>
          </Link> */}


          
        </div>
      </div>
    </div>

    <div id="left_column">
      <div className="left_column">
        <div className="left_content">
          {children}
        </div>
      </div>
    </div>
    
    </div>
  </div>
));

export default Stempel;